import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { pick, equals } from "ramda";
import { Flex, Fieldset } from "@base-ui";
import { SelectOrganizationsGroup, SelectUnitListOrganizations, SelectGender, SelectAgeSpan, SelectPeriodRange, SelectPeriodType, SelectDataSort, SelectRelatedMeasure } from "@domain-ui";
import GraphColorTabs from "./graphColorTabs/GraphColorTabs";
import GraphAdditions from "./graphAdditions/GraphAdditions";
import useSubmeasures from "./useSubmeasures";
import { useUnitListsContext, addVolatileUnits, removeVolatileUnits, SelectUnitListModule } from "@unitLists";
import { useMeasurementsWithMetadata } from "@webapi/hooks/useMeasurementsWithMetadata";
import { measurementsParams } from "utils/measurementsWithMetadata";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function MeasureDetailControlPanel(props) {
  var query = props.query,
    setQuery = props.setQuery,
    metadata = props.metadata,
    reportingUnits = props.reportingUnits;
  var _useUnitListsContext = useUnitListsContext(),
    setUnitLists = _useUnitListsContext.setUnitLists;
  var _useMeasurementsWithM = useMeasurementsWithMetadata(measurementsParams(query)),
    measurementsWithMetadata = _useMeasurementsWithM.measurementsWithMetadata;
  var multipleSubmeasures = query.measureIds.length === 2;
  var isPercent = metadata.measureUnit === "%";
  var isTimeline = query.graphSelected === "timeline";
  var allowedSort = multipleSubmeasures && (isPercent || isTimeline) ? ["unsorted", "alpha", "reverseAlpha"] : ["unsorted", "alpha", "reverseAlpha", "desc", "asc"];
  var dateParams = pick(["periodType", "dateFrom", "dateTo"], query);
  var relatedMeasures = (metadata === null || metadata === void 0 ? void 0 : metadata.relatedMeasures.map(function (id) {
    return {
      id: id,
      label: metadata.library[id].label,
      to: "/indikator/".concat(id, "?relatedmeasuresbyid=").concat(query.relatedMeasuresById, "&relatedmeasuresbyentry=").concat(query.relatedMeasuresByEntry).toLowerCase()
    };
  })) || [];
  var _useSubmeasures = useSubmeasures(query, metadata, setQuery),
    genderSubmeasures = _useSubmeasures.genderSubmeasures,
    ageSubmeasures = _useSubmeasures.ageSubmeasures,
    selectedGenders = _useSubmeasures.selectedGenders,
    selectedAge = _useSubmeasures.selectedAge,
    updateGender = _useSubmeasures.updateGender,
    updateAge = _useSubmeasures.updateAge;
  return /*#__PURE__*/_jsxs(Flex.Column, {
    children: [/*#__PURE__*/_jsx(SelectUnitListOrganizations, {
      selected: query.units,
      reportingUnits: reportingUnits,
      p: "10px 20px 0"
    }), /*#__PURE__*/_jsx(SelectOrganizationsGroup, {
      selected: query.units,
      reportingUnits: reportingUnits,
      includedOptions: ["all-regions", "all-reporting"],
      onChange: function onChange(add, units) {
        return setUnitLists(function (old) {
          return add ? addVolatileUnits(old, units) : removeVolatileUnits(old, units);
        });
      }
    }), /*#__PURE__*/_jsx(SelectUnitListModule, {
      selected: query.units,
      reportingUnits: reportingUnits
    }), /*#__PURE__*/_jsx(Fieldset, {
      legend: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Andra indikatorer f\xF6r: "
        }), metadata === null || metadata === void 0 ? void 0 : metadata.relatedMeasuresByLabel]
      }),
      icon: "openBook",
      children: /*#__PURE__*/_jsx(SelectRelatedMeasure, {
        selected: query.parentMeasure,
        measures: relatedMeasures,
        p: "0 20px"
      })
    }), /*#__PURE__*/_jsxs(Fieldset, {
      legend: "Filtrera data",
      hideLegend: true,
      children: [/*#__PURE__*/_jsx(SelectGender, {
        selected: selectedGenders.current.length > 1 ? "ManWoman" : selectedGenders.current[0] || "Total",
        genders: genderSubmeasures,
        onChange: updateGender,
        allowBoth: true,
        p: "10px 20px 0",
        borderTop: "1px solid #A4DAE2"
      }), /*#__PURE__*/_jsx(SelectAgeSpan, {
        selected: selectedAge.current[0] || "Total",
        ages: ageSubmeasures,
        onChange: updateAge,
        p: "10px 20px"
      }), /*#__PURE__*/_jsx(SelectPeriodType, _objectSpread(_objectSpread({}, dateParams), {}, {
        onChange: setQuery,
        availableTypes: (metadata === null || metadata === void 0 ? void 0 : metadata.periodTypes) || [],
        earliestDataDate: metadata === null || metadata === void 0 ? void 0 : metadata.earliestDataDate,
        lastDataDate: metadata === null || metadata === void 0 ? void 0 : metadata.lastDataDate,
        p: "0 20px 10px"
      })), /*#__PURE__*/_jsx(SelectPeriodRange, _objectSpread(_objectSpread({}, dateParams), {}, {
        onChange: setQuery,
        earliestDataDate: metadata === null || metadata === void 0 ? void 0 : metadata.earliestDataDate,
        lastDataDate: metadata === null || metadata === void 0 ? void 0 : metadata.lastDataDate,
        p: "0 20px 10px"
      }))]
    }), /*#__PURE__*/_jsx(GraphColorTabs, {
      query: query,
      setQuery: setQuery,
      borderTop: "1px solid #A4DAE2"
    }), /*#__PURE__*/_jsx(Fieldset, {
      legend: "Sortering",
      icon: "listArrows",
      children: /*#__PURE__*/_jsx(SelectDataSort, {
        selected: query.sort,
        onChange: function onChange(sort) {
          return setQuery({
            sort: sort
          });
        },
        includedSort: allowedSort,
        p: "0 20px 10px"
      })
    }), /*#__PURE__*/_jsx(GraphAdditions, {
      query: query,
      setQuery: setQuery,
      metadata: metadata,
      measurementsWithMetadata: measurementsWithMetadata
    })]
  });
}, function (prev, curr) {
  return equals(prev, curr);
});